// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { MPFamilies } from '../../constants/families';
import { MP_CARD_HALO_DURATION } from '../../constants/ui';
import MPCardContainer from '../../containers/MPCardContainer';
import { useMPFamilyContext } from '../../contexts/MPFamilyContext';

const OFFSET_CARDS_PERCENT = 70; // %
const CARD_HEIGHT = 78; // px

const StyledMPCardContainer = styled(MPCardContainer)`
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;

  &:first-child {
    z-index: 4;
  }

  &:nth-child(2) {
    transform: translateX(${OFFSET_CARDS_PERCENT}%);
    z-index: 3;
  }

  &:nth-child(3) {
    transform: translateX(${OFFSET_CARDS_PERCENT * 2}%);
    z-index: 2;
  }

  &:nth-child(4) {
    transform: translateX(${OFFSET_CARDS_PERCENT * 3}%);
    z-index: 1;
  }
`;

const FamilyCardsWrapper = styled.div`
  position: relative;
  height: ${CARD_HEIGHT}px;
`;

type MPFamilyCardsProps = {
  className?: string;
};

const MPFamilyCards = ({ className = '' }: MPFamilyCardsProps) => {
  const { familyId } = useMPFamilyContext();
  const familyCardsInfos = useMemo(() => MPFamilies[familyId], [familyId]);

  return (
    <FamilyCardsWrapper className={className}>
      {familyCardsInfos.map((_, index) => (
        <StyledMPCardContainer
          key={`monopoly-family-${familyId}-card-${index}`}
          index={index}
          animationDelay={Math.floor(index * Math.random() * (MP_CARD_HALO_DURATION / familyCardsInfos.length))}
          isClickable
        />
      ))}
    </FamilyCardsWrapper>
  );
};

export default MPFamilyCards;
